export default __webpack_public_path__ + "static/Title_img-swirl-e3c91dc55170971c81394cb1c237643f.png";